var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"StarRating d-flex"},_vm._l((_vm.starsCount),function(vote){return _c('v-svg',{key:vote,staticClass:"icon icon-sm star",class:_vm.iconClass(vote),attrs:{"code":_vm.icon(vote)},nativeOn:{"click":function($event){return _vm.rate(vote)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }